module.exports = __webpack_public_path__ + "static/media/video_2.0bafd71.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/views/help/videos/video_2.mp4
// module id = TC2C
// module chunks = 0